import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar2_1.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              From idea to <span className="purple">production</span>
            </h1>
            <div className="home-about-body">
              <p>
                I’m Wayne Jiang, a full-stack software engineer with{" "}
                <strong className="purple">5+ years of development experience</strong>{" "}
                and a strong focus on backend systems.
              </p>
              <p>
                I independently deliver projects from architecture and development
                through deployment and ongoing maintenance. My experience spans
                Java/Spring Boot services, web and mobile applications, and AI
                agents built with Python, LangChain, and OpenAI APIs.
              </p>
              <p>
                I build retrieval-augmented generation (RAG) workflows that
                connect AI applications to relevant knowledge, and develop
                reusable agent skills for tool use and workflow automation.
              </p>
              <p>
                Beyond building features, I handle database design, performance
                tuning, CI/CD workflows, and production troubleshooting to keep
                applications running reliably.
              </p>
            </div>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-half" alt="avatar"/>
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Wayne-HJ"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/945jht"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/waynehj/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
